import { ForecastSegmentTypeBase } from './base/forecast-segment-type-base';

export class ForecastSegmentType extends ForecastSegmentTypeBase { }